/**
 * @generated SignedSource<<fa1260754fb5bdd7054c1ef6e413cac9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type NavigationInviteButton_project$data = {
  readonly key: string;
  readonly name: string;
  readonly projectId: string | null | undefined;
  readonly " $fragmentType": "NavigationInviteButton_project";
};
export type NavigationInviteButton_project$key = {
  readonly " $data"?: NavigationInviteButton_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavigationInviteButton_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "NavigationInviteButton_project",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "kind": "ScalarField",
      "name": "projectId"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "c8dfc6a1ad69a71ae446c07fdda07a28";

export default node;
